export const QuestionList = [
    {
      question: "Which of the following symptoms related to menstruation have you experienced? Please select all that apply.",
      symptoms: [
        { id: "Menstrual pain (Dysmenorrhea)", text: "Throbbing cramps in lower belly" },
        { id: "Irregular / Missed periods", text: "Irregular / Missed periods" },
        { id: "Constant bleeding", text: "Constant bleeding" },
        { id: "Abnormal uterine bleeding", text: "Bleeding between period or abnormally heavy/long period" },
        { id: "Painful ovulation", text: "Painful ovulation" },
        { id: "Painful cramps during ovulation", text: "Painful cramps during ovulation" },
        { id: "Painful cramps during period", text: "Painful cramps during period"}
      ]
    },
    {
        question: "Which of the following hormonal symptoms have you experienced? Please select all that apply.",
        symptoms: [
          { id: "Weight gain(Y/N)", text: "Weight gain" },
          { id: "Skin darkening (Y/N)", text: "Skin darkening" },
          { id: "Hair loss(Y/N)", text: "Hair loss" },
          { id: "Pimples(Y/N)", text: "Pimples" },
          { id: "hair growth(Y/N)", text: "Excess Hair Growth"}
        ]
      },
    {
      question: "Which of the following gastrointestinal-related symptoms have you experienced recently? Please select all that apply.",
      symptoms: [
        { id: "Constipation / Chronic constipation", text: "Constipation" },
        { id: "Vomiting / constant vomiting", text: "Vomiting" },
        { id: "IBS-like symptoms", text: "IBS-like symptoms" },
        { id: "Painful bowel movements", text: "Painful Bowel movements" },
        { id: "Bowel pain", text: "Bowel pain"}
      ]
    },
    {
      question: "Which of the following general symptoms have you experienced? Please select all that apply.",
      symptoms: [
        { id: "Fatigue / Chronic fatigue", text: "Fatigue / Chronic fatigue" },
        { id: "Malaise / Sickness", text: "Malaise / Sickness" },
        { id: "Fever", text: "Fever" },
        { id: "Loss of appetite", text: "Loss of appetite" },
        { id: "Headaches", text: "Headaches" },
        { id: "Hormonal problems", text: "Hormonal problems" },
        { id: "Bleeding", text: "Bleeding" },
        { id: "Painful / Burning pain during sex (Dyspareunia)", text: "Burning Pain during sex" },
        { id: "Bloating", text: "Bloating"},
        { id: "Feeling sick", text: "Feeling sick"}
      ]
    },
    {
      question: "Have you been diagnosed with any of the below by a medical professional? Select all that apply.",
      symptoms: [
        { id: "Ovarian cysts", text: "Ovarian cysts" },
        { id: "Cysts (unspecified)", text: "Cysts (unspecified)" },
        { id: "Fertility Issues", text: "Fertility Issues" },
        { id: "Infertility", text: "Infertility" }
      ]
    },
    {
      question: "Do you exercise regularly?",
      symptoms: [
        { id: "Reg.Exercise(Y/N)", text: "Yes" },
        { id: "No", text: "No" }
      ]
    },
    {
      question: "Do you consume fast food?",
      symptoms: [
        { id: "Fast food (Y/N)", text: "Yes" },
        { id: "No", text: "No" }
      ]
    }
  ];
  